import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  loadEcardDraft,
  saveEcardDraft,
  getJourneyBySlug,
  loadEcardAccount,
} from "../constants/giftJourney";
import "../styles/journey.css";
import "../styles/productDetails.css";

const SHARE_METHODS = [
  { id: "whatsapp", label: "WhatsApp" },
  { id: "email", label: "Email" },
  { id: "instagram", label: "Instagram DM/Story" },
  { id: "anywhere", label: "Any app (system share)" },
];

function toLocalInputValue(ms) {
  const d = new Date(ms);
  const pad = (v) => String(v).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
}

export default function ProductSchedule() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const occasion = searchParams.get("occasion") || "egift";
  const journey = getJourneyBySlug(occasion);

  const [scheduledAt, setScheduledAt] = useState(toLocalInputValue(Date.now() + 3600 * 1000));
  const [method, setMethod] = useState("whatsapp");
  const [deliveryEmail, setDeliveryEmail] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    const d = loadEcardDraft(id);
    if (!d || !d.recipientName) {
      navigate(`/product/${id}/customize?occasion=${encodeURIComponent(occasion)}`, {
        replace: true,
      });
      return;
    }
    if (d.schedule?.scheduledAt) {
      setScheduledAt(toLocalInputValue(Number(d.schedule.scheduledAt)));
      setMethod(String(d.schedule.method || "whatsapp"));
      setDeliveryEmail(String(d.schedule.emailTo || ""));
    } else {
      const account = loadEcardAccount(id);
      if (account?.email) setDeliveryEmail(String(account.email));
    }
  }, [id, navigate, occasion]);

  const handleSave = (e) => {
    e.preventDefault();
    setErr("");
    const d = loadEcardDraft(id);
    if (!d || !d.recipientName) {
      navigate(`/product/${id}/customize?occasion=${encodeURIComponent(occasion)}`, {
        replace: true,
      });
      return;
    }
    const ms = new Date(scheduledAt).getTime();
    if (!Number.isFinite(ms) || ms <= Date.now()) {
      setErr("Please choose a future date and time.");
      return;
    }
    const emailTo = String(deliveryEmail || "").trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTo)) {
      setErr("Please enter a valid email for scheduled delivery.");
      return;
    }

    saveEcardDraft(id, {
      ...d,
      occasionSlug: journey.slug,
      schedule: {
        enabled: true,
        scheduledAt: ms,
        method,
        emailTo,
      },
    });
    navigate(`/product/${id}/account`);
  };

  return (
    <div className="pd-wrap">
      <div className="journey-panel journey-customize journey-customize--form-only">
        <div className="journey-customize-head">
          <Link
            to={`/product/${id}/customize?occasion=${encodeURIComponent(occasion)}`}
            className="journey-link-back"
          >
            ← Back to message
          </Link>
          <span className="journey-pill">{journey.label}</span>
          <h1>Schedule your e-card delivery</h1>
          <p>
            Choose when this e-card should be delivered and how you want to share it at that time.
          </p>
        </div>

        <form className="journey-form journey-form--wide" onSubmit={handleSave}>
          <label className="journey-field">
            <span>Date & time</span>
            <input
              type="datetime-local"
              value={scheduledAt}
              onChange={(e) => setScheduledAt(e.target.value)}
              required
            />
          </label>

          <label className="journey-field">
            <span>Share method when occasion time arrives</span>
            <select
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              className="journey-coupon-input"
            >
              {SHARE_METHODS.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.label}
                </option>
              ))}
            </select>
          </label>

          <label className="journey-field">
            <span>Email to receive share link at scheduled time</span>
            <input
              type="email"
              value={deliveryEmail}
              onChange={(e) => setDeliveryEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </label>

          <p className="journey-hint-small">
            At the scheduled time, your share page will guide you to send through this method in one
            click.
          </p>

          {err ? <p className="pd-error journey-inline-err">{err}</p> : null}

          <div className="journey-form-actions pd-customize-actions">
            <button type="submit" className="pd-btn pd-btn-pay">
              Save schedule and continue →
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
